var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.loading)?_c('div',[_c('global-top-message'),(_vm.$store.getters.isAuthenticated)?_c('navbar'):_vm._e(),_c('notifications',{attrs:{"classes":"fb-vue-notification","position":"top right"}}),_c('router-view')],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }